/*
 * AnnouncementsPage sagas
 */

import {call, put, takeLatest} from 'redux-saga/effects';
import * as api from 'utils/api';
import {REMOVE_ANNOUNCEMENT, GET_IMAGE_LINK} from './constants';
import {removeAnnouncementError, removeAnnouncementSuccess} from "./actions";
import {setImageLink} from "containers/Announcement/actions";


export default function* rootSaga() {
    yield takeLatest(REMOVE_ANNOUNCEMENT, removeAnnouncementSaga);
    yield takeLatest(GET_IMAGE_LINK, getImageLinkSaga)
}

export function* removeAnnouncementSaga({payload: {id}}) {
    try {
        yield call(api.addAnnouncementsLink, id);
        yield put(removeAnnouncementSuccess())
    } catch (err) {
        console.log(err)
        yield put(removeAnnouncementError(err));
    }
}

export function* getImageLinkSaga({meta, payload}) {
    const response = yield call(api.createDownloadTicket, payload.fileId);
    const link = yield call(api.getDownloadLink, response.data.ticketId)
    yield put(setImageLink(link, meta));
}

